'use client';

import { PrismicLink, SliceComponentProps } from '@prismicio/react';
import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import styles from './blog-references.module.scss';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import { Content, FilledLinkToWebField } from '@prismicio/client';

type BlogReferencesProps = SliceComponentProps<Content.BlogReferencesSlice>;

const BlogReferences = ({ slice }: BlogReferencesProps) => {
    const [open, setOpen] = useState(false);

    const iconExpandCollapse = open ? faAngleUp : faAngleDown;

    const referencesNo = slice.items.length;

    return (
        <section className={styles['blog-references']}>
            <div
                onClick={() => setOpen(!open)}
                className="mb-2 flex cursor-pointer items-center justify-between"
            >
                <h3 className={styles['blog-references__header']}>
                    {referencesNo > 1 && referencesNo} References
                </h3>
                <FontAwesomeIcon
                    icon={iconExpandCollapse}
                    className={'h-4 w-4'}
                />
            </div>
            <div
                className={classNames(
                    styles['blog-references__content'],
                    open && styles['open'],
                )}
            >
                {slice.items.map((item, i) => (
                    <PrismicLink key={i} field={item.reference_link}>
                        {i + 1}.{' '}
                        {(item.reference_link as FilledLinkToWebField).url}
                    </PrismicLink>
                ))}
            </div>
        </section>
    );
};

export default BlogReferences;
